// @flow

// RGSSUP-218
const businessOperation = {
	ReceivingRegistrationData: 1,

	// RGGSUP-22188 - удалено
	ReceivingAdditionalRegistrationData: 2,

	SendingPasswordToUser: 3,
	CreatingUserProfile: 4,
	ReceivingCalculatorModel: 8,
	ShowingDataForCheck: 9,
	ReceivingCheckedData: 10,

	ReceivingDocumentCopies: 11,

	//RGSSUP-22728: Логирование БСО удалено
	OrderingBSO: 12,

	UserProvideIncorrectData: 18,

	//RGSSUP-22728: Логирование БСО удалено
	TellingUserAboutPrice: 19,
	ReceivingChosenPaymentMethod: 20,
	ReceivingAgreementAndPaymentPeriod: 21,
	ReceivingPaymentConfirmation: 22,
	AttachingPaymentDocuments: 23,

	ReceivingPolicyChange: 26,

	ShowingLinkToAnotherCompany: 38,
	UserLeftForAnotherCompany: 39,

	ApplyRsaRedirect: 45,
	RejectRsaRedirect: 46,

	ConfirmationDocumentProviding: 62,

	// NOTE: до RGSSUP-29219 событие писалось с кодом 138
	ShowingLinkToRsa: 47,

	//RGSSUP-22728: Логирование БСО удалено
	BsoInformed: 110,

	SendingDocumentCopiesForCheck: 111,
	TellingUserAboutIncorrectData: 108,
	
	ImpossibleContinuingConcludingContract: 150,
};

export type BusinessOperation = $Keys<typeof businessOperation>;

export function toNumber (op: BusinessOperation): number {
	return businessOperation[op];
}
